import React from 'react'
import cls from 'classnames'
import ReactDOM from 'react-dom'
import styled from 'styled-components'

const ESCAPE = 27

class OldModal extends React.Component {
  state = {
    /**
     * Render Modal children only after mounted.
     * https://github.com/reactjs/reactjs.org/issues/272
     */
    mounted: false,
  }

  el = document.createElement('div')

  mountNode = document.body

  componentDidMount() {
    this.mountNode.appendChild(this.el)
    document.addEventListener('keydown', this.handleKeyDown)
    document.querySelector('body').classList.add('oh')
    this.setState({ mounted: true })
  }

  componentWillUnmount() {
    this.mountNode.removeChild(this.el)
    document.removeEventListener('keydown', this.handleKeyDown)
    document.querySelector('body').classList.remove('oh')
  }

  onClose = () => {
    if (typeof this.props.onClose === 'function') {
      this.props.onClose()
    }
  }

  handleKeyDown = (event) => {
    if (event.keyCode === ESCAPE) {
      this.onClose()
    }
  }

  stopPropagation = (e) => e.stopPropagation()

  render() {
    const {
      className,
      noOutClickClose,
      onClose,
      noXClose,
      children,
      xOutsideModal,
      style,
      contentStyle,
    } = this.props

    return (
      <>
        {ReactDOM.createPortal(
          this.state.mounted ? (
            <div
              className={cls('is-modal', className)}
              onClick={noOutClickClose ? null : this.onClose}
              style={style}
            >
              <div style={contentStyle} className="content" onClick={this.stopPropagation}>
                {typeof onClose === 'function' && !noXClose && (
                  <span
                    className={cls('close-btn', {
                      'outside-modal': xOutsideModal,
                    })}
                    onClick={this.onClose}
                  >
                    <img src="/static/webapp/icons/close.svg" />
                  </span>
                )}
                {React.cloneElement(children, {
                  modalCloseSelf: this.onClose,
                })}
              </div>
            </div>
          ) : null,
          this.el
        )}
      </>
    )
  }
}

/**
 * @deprecated use Modal.js instead.
 */

const size = (props) => {
  if (props.fullscreen) {
    return `
      position: absolute;
      top: 10px;
      bottom: 10px;
      left:  50px;
      right:  50px;
    `
  } else if (props.medium) {
    return `
      width: 1024px;
      margin: 50px auto;
    `
  } else if (props.large) {
    return `
      width: 80%;
      margin: 50px auto;
    `
  } else if (props.deleteModal) {
    return `
      width: 400px;
      height: 230px;
      margin: 50px auto;
      top: 25%;
    `
  } else if (props.changeRoleModal) {
    return `
      width: 400px;
      margin: 50px auto;
      top: 25%;
    `
  } else if (props.errorModal) {
    return `
      width: 350px;
      height: 160px;
      margin: 50px auto;
      top: 25%;
    `
  } else if (props.permissionsNewItem) {
    return `
      width: 480px;
      height: 315px;
      margin: 50px auto;
      top: 30%;
    `
  } else if (props.datePicker) {
    return `
      width: 350px;
      left: 40%;
      top: 30%;
    `
  } else if (props.newRelease) {
    return `
      width: 680px;
      margin-right: auto;
      margin-left: auto;
    `
  } else if (props.trainingVideo) {
    return `
      width: 900px;
      margin-right: auto;
      margin-left: auto;
      transform: none;
      top: 20%;
    `
  } else if (props.lms) {
    return `
      width: 90vw;
      height: 85vh;
      margin-right: auto;
      margin-left: auto;
      transform: none;
      top: 10%;
    `
  } else if (props.changedState) {
    return `
      width: 560px;
      min-height: 400px;
      margin-right: auto;
      margin-left: auto;
    `
  } else if (props.accountSetupVideoModal) {
    return `
      width: 860px;
      height: 580px;
      border-radius: 13px;
      margin-right: auto;
      margin-left: auto;
    `
  } else if (props.campaignQuickLaunchModal) {
    return `
      width: 768px;
      margin: 50px auto;
    `
  } else if (props.languageModal) {
    return `
        height: 75% !important;
        width: 30%;
        left: 40%;
        top: 40%;
    `
  } else if (props.width) {
    return `
      width: ${props.width};
      margin-right: auto;
      margin-left: auto;
    `
  }
  // defaults to small modal
  return `
      width: 768px;
      margin: 50px auto;
    `
}

export default styled(OldModal)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${(props) => props.theme.zIndexModal};
  overflow-y: auto;
  background: ${(props) => props.theme.modalBackgroundColor};
  & > .content {
    height: auto;
    min-height: 47px;
    padding: ${(props) => !props.contentNoDefaultPadding && '10px'};
    border-radius: 16px;
    position: relative;
    top: 50%;
    /* transform properly supposed to be removed in future, 'top' does the same */
    ${(props) => !props.disableTransform && 'transform: translateY(-50%);'}
    background: white;
    box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.25);
    .content-container {
      text-align: center;
    }
    ${(props) => size(props)}
    ${(props) => props.contentTopOffset && `top: ${props.contentTopOffset};`}
    ${(props) => props.contentMargin && `margin: ${props.contentMargin};`}
    ${(props) => props.width && `width: ${props.width};`}
    ${(props) => props.height && `height: ${props.height};`}
    @media screen and (max-width: ${(props) => props.theme.rcTabletPoint}) {
      width: 100%;
    }
    .close-btn {
      width: 28px;
      height: 28px;
      border-radius: 4px;
      position: absolute;
      top: 16px;
      right: 16px;
      z-index: ${(props) => props.theme.zIndexModalX};
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &.outside-modal {
        @media screen and (min-width: ${(props) => props.theme.rcTabletPointMin}) {
          width: 24px;
          height: 24px;
          border-radius: 16px;
          top: -24px;
          right: -24px;
          background: #ffffff;
          box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.25);
        }
      }
      &:hover {
        background: #e6e9ee;
      }
    }
  }
`
